module.exports = __webpack_public_path__ + "static/media/Technologybanner@3x.cbdd19ea.png";